<template>
  <div class="campaign-field-row">
    <CampaignFieldsCardRowDate
      v-if="input_type == 'date'"
      :name="name"
      :description="description"
      :date_type="date_type"
      :date_format="date_format"
      :value="value"
      @updateFieldValue="updateFieldValue"
    />
    <component
      v-else
      :is="isSelect ? 'v-select' : 'v-text-field'"
      :value="value"
      v-bind="{ label: name, items: list_values }"
      :rules="[
        is_number,
        required,
        v_min_length,
        v_max_length,
        (v) => forbidden_chars(v, forbiddenChars),
      ]"
      :counter="!noMaxValue && max_length"
      data-tid="field-input"
      item-text="name"
      color="secondary"
      @input="updateFieldValue"
    >
      <v-tooltip slot="append" top>
        <v-icon slot="activator">info_outline</v-icon>
        <span>{{ description }}</span>
      </v-tooltip>
    </component>
  </div>
</template>

<script>
import CampaignFieldsCardRowDate from "@/components/CampaignFieldsCardRowDate";
import { mapGetters } from "vuex";
import inputValidation from "@/mixins/inputValidation";

export default {
  components: {
    CampaignFieldsCardRowDate,
  },
  mixins: [inputValidation],
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: "",
    },
    input_type: {
      type: String,
      required: true,
    },
    is_required: {
      type: Boolean,
      required: false,
      default: false,
    },
    min_length: {
      type: Number,
      required: false,
      default: 0,
    },
    max_length: {
      type: Number,
      required: false,
      default: 0,
    },
    list_values: {
      type: Array,
      required: false,
      default: () => [],
    },
    has_second_list_value: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    date_type: {
      type: String,
      required: false,
      default: "",
    },
    date_format: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    isSelect() {
      return this.input_type === "select";
    },
    noMinValue() {
      return this.isSelect || !this.min_length;
    },
    noMaxValue() {
      return this.isSelect || !this.max_length;
    },
    ...mapGetters("admins", ["superAdmin"]),
    forbiddenChars() {
      return this.superAdmin.content[0].forbidden_chars;
    },
  },
  methods: {
    updateFieldValue(value) {
      const item =
        this.isSelect && this.list_values.find((item) => item.value === value);
      const secondValue = item && this.has_second_list_value && item.value2;
      this.$emit("updateFieldValue", this.id, value, secondValue);
    },
    required(val) {
      return !this.is_required || !!val || "Value is required.";
    },
    v_min_length(val) {
      return (
        this.noMinValue ||
        val.length >= this.min_length ||
        `Min length is ${this.min_length}`
      );
    },
    v_max_length(val) {
      return (
        this.noMaxValue ||
        !val ||
        val.length <= this.max_length ||
        `Max length is ${this.max_length}`
      );
    },
    is_number(val) {
      return (
        this.input_type != "number" || !isNaN(val) || "Value must be a Number"
      );
    },
  },
};
</script>
